module.exports = __webpack_public_path__ + "img/used-images.2ff15d28.png";